import { FC, RefObject } from 'react';

import { useActStepperEngine } from '@gasbi/shared/web/components/ActStepperEngine';

import Stack from '@mui/joy/Stack';

import {
  DateChip,
  MeteringPointActTitleMessage,
  StyledActFormTitleContainer,
} from '@components/ActsAndDocumentsForm';

import BridgeActs from '@assets/BridgeActs.svg?react';

type ActFormTitleProps = {
  buttonRef: RefObject<HTMLDivElement>;
};

export const ActFormTitle: FC<ActFormTitleProps> = ({ buttonRef }) => {
  const stepData = useActStepperEngine(s => s.stepsState['Information']?.data);

  return (
    <StyledActFormTitleContainer>
      <MeteringPointActTitleMessage
        icon={<BridgeActs />}
        level='h4'
        actNumber={stepData?.number}
        startDate={stepData?.date && <DateChip startDate={stepData.date} />}
        text='Акт про порушення'
      />
      <Stack
        ref={buttonRef}
        id='containerId'
        direction='row'
        flex={1}
        justifyContent='flex-end'
      />
    </StyledActFormTitleContainer>
  );
};
